import { DateRange } from 'react-day-picker';

import useAnalytics, { EMetric } from 'api/useAnalytics';

import {
  DEFAULT_DATE_RANGE,
  getWholeRange,
} from '../utils';

interface UseAnalyticsDataParams {
  apiDateRange: DateRange | undefined;
  apiPreviousDateRange: DateRange | undefined;
  publisherId: string | undefined;
  statsMetrics: EMetric[];
  trendsMetrics: EMetric[];
  breakdownsMetrics: EMetric[];
  attributeFilters?: Record<string, string[]>;
}

export const useAnalyticsData = ({
  apiDateRange,
  apiPreviousDateRange,
  publisherId,
  statsMetrics,
  trendsMetrics,
  breakdownsMetrics,
  attributeFilters,
}: UseAnalyticsDataParams) => {
  const analytics = useAnalytics(
    apiDateRange?.from?.toISOString() ??
      getWholeRange(DEFAULT_DATE_RANGE)!.from!.toISOString(),
    apiDateRange?.to?.toISOString() ??
      getWholeRange(DEFAULT_DATE_RANGE)!.to!.toISOString(),
    statsMetrics,
    trendsMetrics,
    breakdownsMetrics,
    publisherId,
    attributeFilters
  );

  const previousAnalytics = useAnalytics(
    apiPreviousDateRange?.from?.toISOString(),
    apiPreviousDateRange?.to?.toISOString(),
    statsMetrics,
    trendsMetrics,
    breakdownsMetrics,
    publisherId,
    attributeFilters
  );

  const isLoading =
    analytics.getAnalytics.isLoading ||
    analytics.getTrends.isLoading ||
    previousAnalytics.getAnalytics.isLoading ||
    previousAnalytics.getTrends.isLoading;

  return {
    analytics,
    previousAnalytics,
    isLoading
  };
};
